import React from 'react';
import { Link } from 'react-router-dom';
import { Image, Button, Container, Text, Box /* Link as LinkChakra*/ } from '@chakra-ui/react';
import preval from 'preval.macro';
import Footer from '../components/Footer';

function Darsena() {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';
  const imgUrl = `/images/${process.env.REACT_APP_PROJECT_ID}`;

  return (
    <Container my={50} bg='#3c4d5f' centerContent>
      {isDemo && (
        <Text color={'gold'} mb={10} fontSize={'3xl'} fontWeight={600}>
          DEMO
        </Text>
      )}

      <Image src={`${imgUrl}/logo.png`} alt='Carnevaldarsena logo' />

      <Text my={5} color={'brand.yellow'} fontSize={'4xl'} fontWeight={600} textAlign='center'>
        🧘🏻‍♀️ Lucy Yoga 🧘🏻‍♂️
      </Text>

      {/* SPONSOR */}
      {/* <Image  w={'200px'} src='/images/sponsor.jpg' alt='Sponsor' /> */}

      {/* </HStack> */}

      <Text my={10} color={'white'} fontSize={'xl'}>
        Namastè!
        <br />
        {/* <Text color='brand.yellow'>
          Lucy Yoga
        </Text>  */}
        Ti diamo il benvenuto nel nostro mondo.
        <br />
        <br />
        Da qui potrai prenotare le tue Class Special di yoga,
        ti aspettiamo! ❤️
      </Text>
      <Button as={Link} to='menu' mt={37} w={'300px'} h={'60px'} size={'lg'} fontSize={'30px'}>
        Entra
      </Button>

      {/* SPONSOR */}
      {/* <LinkChakra href='https://popular-pagamenti.web.app'>
      <Button mt={10} w={'300px'} h={'40px'} size={'lg'} fontSize={'25px'}>
        I nostri sponsor
      </Button>
      </LinkChakra> */}
      {/* <Button as={Link} to='sponsor' mt={10} w={'300px'} h={'40px'} size={'lg'} fontSize={'25px'}>
          I nostri sponsor
        </Button> */}

      {/* SPONSOR */}
      {/* <Image mt={10} w={'200px'} src={`${imgUrl}/sponsor/oropiu.png`} alt='Sponsor' /> */}

      {/* SUPPORTO */}
      <Button as={Link} to='support' mt={37} size={'md'} fontSize={'20px'}>
        Hai smarrito il tuo ordine?
      </Button>

      <Box mt={10}>
        <Footer />
        <Text textAlign='center' fontSize={12} mt={2}>
          {preval`module.exports = new Date().toLocaleString();`}
        </Text>
      </Box>
    </Container>
  );
}

export default Darsena;
